module.exports = {
  APP_NAME: 'navbar-ui',
  FEATURE_TOGGLE: 'fex_team_only',
  FEATURE_FLAG: 'better_global_nav',
  API_BASE_PATH: '/api/v2/',
  URL_STRING: 'navbar-ui',
  BASE_PATH: '/',
  CONTENTFUL_SPACE: 'j8nzv6dy3jwc',
  CONTENTFUL_TOKEN: 'IVHEcGlRMf_3HSZaS3_VyW_xyianfoxngUXyskkMZx0',
  LOGO_TYPE: 'DEFAULT',
  BUGSNAG_API_KEY: '9f5f33755cc8588b83f1a94ee94c6220'
};
